import {useState, useEffect, MouseEventHandler} from 'react'
import {createPortal} from 'react-dom'
import * as Yup from 'yup'
import {Modal} from 'react-bootstrap'
import {defaultQcEnrollment} from './InterfaceQcModal'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import closeIcon from '../../../../_metronic/images/closeSymbol.svg'
import {useFormik} from 'formik'
import {alert, arrayMove} from '../../../../utils/helper'
import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
  OnChangeValue,
  Props,
} from 'react-select'
import {
  SortableContainer,
  SortableContainerProps,
  SortableElement,
  SortEndHandler,
  SortableHandle,
} from 'react-sortable-hoc'
import '../../../shared-css/tagify.css'
import './qc.css'
import {
  CREATE_QC_USER,
  UPDATE_QC_USER,
  KEY_PERFORMANCE_METRICS_FILTER,
  GET_USER_BY_ID,
} from '../../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'

const MySwal = withReactContent(Swal)

type PropsValue = {
  show: boolean
  handleClose: () => void
  refetchList: () => void
  method: string
  editId: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const enrollSchema = Yup.object().shape({
  qcFirstName: Yup.string()
    .required('First Name is required')
    .matches(/^[0-9a-zA-Z \b]+$/, 'Special characters are not allowed')
    .matches(/^[^-\s][a-zA-Z0-9_\s-]+$/, 'Space not allowed')
    .min(3, "First Name shouldn't be less than 3 characters")
    .max(40, "First Name shouldn't exceed 40 characters"),
  qcLastName: Yup.string()
    .required('Last Name is required')
    .matches(/^[0-9a-zA-Z \b]+$/, 'Special characters not allowed')
    .matches(/^[^-\s][a-zA-Z0-9_\s-]+$/, 'Space not allowed')
    .min(3, "Last Name shouldn't be less than 3 characters")
    .max(40, "Last Name shouldn't exceed 40 characters"),
  qcEmail: Yup.string()
    .required('Email ID is required')
    .email('Email ID not Valid')
    .matches(/^(?!.*@[^,]*,)/, 'Email ID not Valid')
    .min(10, "Email ID shouldn't be less than 10 characters")
    .max(40, "Email ID shouldn't exceed 40 characters"),
})

const SortableMultiValue = SortableElement((props: MultiValueProps<any>) => {
  // this prevents the menu from being opened/closed when the user clicks
  // on a value to begin dragging it. ideally, detecting a click (instead of
  // a drag) would still focus the control and toggle the menu, but that
  // requires some magic with refs that are out of scope for this example
  const onMouseDown: MouseEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }
  const innerProps = {...props.innerProps, onMouseDown}
  return <components.MultiValue {...props} innerProps={innerProps} />
})

const SortableMultiValueLabel = SortableHandle((props: MultiValueGenericProps) => (
  <components.MultiValueLabel {...props} />
))

const SortableSelect = SortableContainer(Select) as React.ComponentClass<
  Props<ColourOption, true> & SortableContainerProps
>
export interface ColourOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

const CreateQcModal = ({show, handleClose, refetchList, method, editId}: PropsValue) => {
  const networkOnly = 'network-only'
  const [salesChannel, setSalesChannel] = useState<any>([])
  const [scValidation, setScValidation] = useState<any>('')
  const [btnDisabled, setBtnDisabled] = useState<boolean>(false)
  const [editqcData, setEditqcdata] = useState<any>()
  const [selected, setSelected] = useState<readonly ColourOption[]>([])
  const [selectedId, setSelectedId] = useState<any>([])

  const onChange = (selectedOptions: OnChangeValue<ColourOption, true>, actionType: any) => {
    setSelected(selectedOptions)
    setSelectedId(
      selectedOptions.map((item: any) => {
        return {
          id: item.id || item.value,
        }
      })
    )

    if (selectedOptions.length === 0) {
      setScValidation('Sales Channel is required')
      setBtnDisabled(true) //(prev)=>{return !prev}
    } else {
      setScValidation('')
      setBtnDisabled(false)
    }
  }

  const onSortEnd: SortEndHandler = ({oldIndex, newIndex}) => {
    const newValue = arrayMove(selected, oldIndex, newIndex)
    setSelected(newValue)
  }

  useEffect(() => {
    if (method === 'create') {
      formik.setValues({...defaultQcEnrollment})
    } else if (editId) {
      getQcuserById()
    }
    // reseting the form when closed
    formik.resetForm()
    formik.setValues({...defaultQcEnrollment})
    setSelectedId([])
    setSelected([])
    setScValidation('')
    setBtnDisabled(false)
  }, [show, editId])

  const formik = useFormik({
    initialValues: defaultQcEnrollment,
    validationSchema: enrollSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      let error = false
      if (handleSCValidation()) {
        error = true
      }
      if (error) {
        return
      }
      if (method === 'create') {
        createQCUserEnrollment({
          variables: {
            createQcUserInput: {
              salesChannels: selectedId,
              firstName: values.qcFirstName,
              lastName: values.qcLastName,
              emailId: values.qcEmail,
            },
          },
        })
      } else if (method === 'edit') {
        updateQCUserEnrollment({
          variables: {
            updateQcUserInput: {
              salesChannels: selectedId, //selectedSalesChannelID,
              id: editqcData.id,
              firstName: values.qcFirstName,
              lastName: values.qcLastName,
              emailId: values.qcEmail,
            },
          },
        })
      }
    },
  })

  // GET_BY_ID_EDIT
  const [getQcuserById] = useLazyQuery(GET_USER_BY_ID, {
    fetchPolicy: networkOnly,
    variables: {
      id: editId,
    },
    onCompleted: (qcUserData) => {
      const editQcEnrollment = {
        id: qcUserData.getQcUserById.id,
        qcFirstName: qcUserData.getQcUserById.firstName,
        qcLastName: qcUserData.getQcUserById.lastName,
        qcEmail: qcUserData.getQcUserById.emailId,
        salesChannel: qcUserData.getQcUserById.salesChannels, //need to check on it
      }
      formik.setValues({...editQcEnrollment})
      setSelected(
        qcUserData.getQcUserById.salesChannels.map((each: any) => {
          return {id: each.id, value: each.id, label: each.name, name: each.name}
        })
      )
      setSelectedId(qcUserData.getQcUserById.salesChannels.map((each: any) => ({id: each.id})))
      setEditqcdata(editQcEnrollment)
    },
  })

  // CREATE
  const [createQCUserEnrollment, { loading }] = useMutation(CREATE_QC_USER, {
    onCompleted: (data) => {
      if (data.createQcUser.id) {
        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: 'QC User created successfully',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        }
        MySwal.fire(options)
        formik.setValues({...defaultQcEnrollment})
      } else {
        MySwal.fire({
          icon: 'error',
          title: 'Error in creating customer',
        })
      }
      refetchList()
      handleClose()
    },
    onError: (e) => alert(e.message, 'error'),
  })

  // UPDATE
  const [updateQCUserEnrollment, { loading: IsLoading }] = useMutation(UPDATE_QC_USER, {
    fetchPolicy: networkOnly,
    onCompleted: (data) => {
      if (data.updateQcUser.id) {
        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: 'QC User updated successfully',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        }
        MySwal.fire(options)
        formik.setValues({...defaultQcEnrollment})
      } else {
        MySwal.fire({
          icon: 'error',
          title: 'Error in creating customer',
        })
      }
      refetchList()
      handleClose()
    },
    onError: (e) => alert(e.message, 'error'),
  })

  // Tagify Sales Channel Fetch
  const [getSalesChannelsForFilter] = useLazyQuery(KEY_PERFORMANCE_METRICS_FILTER, {
    fetchPolicy: networkOnly,
    onCompleted: (data: any) => {
      setSalesChannel(
        data.getSalesChannelListByTeamAdminWithFilter.salesChannels.map((x: any) => ({
          ...x,
        }))
      )
    },
  })
  useEffect(() => {
    getSalesChannelsForFilter({
      variables: {
        salesChannelListInput: {
          searchText: '',
          page: 1,
          perPage: 100,
        },
      },
    })
  }, [])

  // Sales Channel Input Validation
  const handleSCValidation = () => {
    let result = false
    if (selectedId) {
      if (selectedId.length === 0) {
        setScValidation('Sales Channel is required')
        setBtnDisabled(true)
        result = true
      } else {
        setScValidation('')
        setBtnDisabled(false)
        // result = true
      }
    }
    return result
  }

  const handleDataAfterClose = () => {
    handleClose()
    formik.resetForm()
    formik.setValues({...defaultQcEnrollment})
    setSelectedId([])
    setSelected([])
    setScValidation('')
    setBtnDisabled(false)
  }
  const btnLoader = IsLoading || loading
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-650px'
      show={show}
      onHide={handleDataAfterClose}
      backdrop={true}
    >
      <div className='modal-header'>
        <h4 className='modal-title '>Add QC User</h4>
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={handleDataAfterClose}
        >
          <img className='svg-icon-1' src={closeIcon} alt='close' />
        </div>
      </div>

      <div className='modal-body'>
        <form noValidate id='kt_modal_create_app_form' onSubmit={formik.handleSubmit}>
          <div className='modal-md'>
            <div className='modal-content'>
              <div className='modal-body'>
                <div className='mb-9'>
                  <label className='form-label'>
                    QC First Name <span className='h5 text-danger'>*</span>
                  </label>
                  <input
                    type='text'
                    className='form-control form-control-solid'
                    placeholder='Enter QC First Name'
                    {...formik.getFieldProps('qcFirstName')}
                  />
                  {formik.touched.qcFirstName && formik.errors.qcFirstName && (
                    <div className='fv-plugins-message-container'>
                      <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                        {formik.errors.qcFirstName}
                      </div>
                    </div>
                  )}
                </div>
                <div className='mb-9'>
                  <label className='form-label'>
                    QC Last Name <span className='h5 text-danger'>*</span>
                  </label>
                  <input
                    type='text'
                    className='form-control form-control-solid'
                    placeholder='Enter QC Last Name'
                    {...formik.getFieldProps('qcLastName')}
                  />
                  {formik.touched.qcLastName && formik.errors.qcLastName && (
                    <div className='fv-plugins-message-container'>
                      <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                        {formik.errors.qcLastName}
                      </div>
                    </div>
                  )}
                </div>
                <div className='mb-9'>
                  <label className='form-label'>
                    QC Email ID <span className='h5 text-danger'>*</span>
                  </label>
                  <input
                    type='email'
                    className='form-control form-control-solid'
                    placeholder='Enter Email ID'
                    // disabled={emailDisabled}
                    {...formik.getFieldProps('qcEmail')}
                  />
                  {formik.touched.qcEmail && formik.errors.qcEmail && (
                    <div className='fv-plugins-message-container'>
                      <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                        {formik.errors.qcEmail}
                      </div>
                    </div>
                  )}
                </div>

                <div className='mb-7'>
                  <label className='form-label'>
                    Sales Channel <span className='h5 text-danger'>*</span>
                  </label>
                  <SortableSelect
                    useDragHandle
                    required
                    // react-sortable-hoc props:
                    axis='xy'
                    onSortEnd={onSortEnd}
                    distance={4}
                    // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
                    getHelperDimensions={({node}) => node.getBoundingClientRect()}
                    // react-select props:
                    isMulti
                    options={salesChannel?.map((channelName: any) => {
                      return {
                        id: channelName.id,
                        value: channelName.id,
                        label: channelName.name,
                        name: channelName.name,
                        __typename: 'SalesChannel',
                      }
                    })}
                    value={selected}
                    onChange={onChange}
                    components={{
                      // @ts-ignore We're failing to provide a required index prop to SortableElement
                      MultiValue: SortableMultiValue,
                      //MultiValueLabel: SortableMultiValueLabel,
                    }}
                    closeMenuOnSelect={false}
                  />
                  {scValidation && (
                    <div className='fv-plugins-message-container'>
                      <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                        {scValidation}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='modal-footer'>
                <button
                  type='button'
                  className='btn btn-light'
                  data-bs-dismiss='modal'
                  onClick={() => handleDataAfterClose()}
                >
                  Discard
                </button>
                <button type='submit' className='btn btn-primary' disabled={btnDisabled || btnLoader}>
                  {btnLoader && (
                    <span
                      className="spinner-border spinner-border-sm text-white"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  {btnLoader ? " Submiting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>,
    modalsRoot
  )
}

export { CreateQcModal }
